<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar bgc-header">
          <CIcon size="lg" class="font-header-white m-0" name="cil-user" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="d-flex bgc-header">
      <div class="c-avatar bgc-header-white mr-2">
        <CIcon size="lg" class="font-header m-0" name="cil-user" />
      </div>
      <div class="d-flex flex-column font-header font-header-white">
        <strong>{{ this.userName }}</strong>
        <span>{{ this.email }}</span>
      </div>
    </CDropdownHeader>
    <CDropdownItem class="no-padding">
      <router-link class="router-width" :to="{ name: 'change' }">
        <div class="custom-padding">
          <CIcon class="mb-1" name="cil-lock-locked" />Cambiar contraseña
        </div>
      </router-link>
    </CDropdownItem>
    <CDropdownItem v-if="isAdmin" class="no-padding">
      <router-link class="router-width" :to="{ name: 'perfiles' }">
        <div class="custom-padding">
          <CIcon class="mb-1" name="cil-user" />Perfiles de usuario
        </div>
      </router-link>
    </CDropdownItem>
    <CDropdownItem v-if="isAdmin" class="no-padding">
      <router-link class="router-width" to="/usuarios">
        <div class="custom-padding">
          <CIcon class="mb-1" name="cil-user-follow" />Usuarios
        </div>
      </router-link>
    </CDropdownItem>

    <CDropdownItem class="no-padding">
      <!-- <router-link class="router-width" :to="{ name: 'Login'}"> -->
      <div @click="logout()" class="custom-padding">
        <CIcon class="mb-1" name="cil-account-logout" />Cerrar sesion
      </div>
      <!-- </router-link> -->
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42
    };
  },
  computed: {
    email() {
      return this.$store.state.email;
    },
    userName() {
      return this.$store.state.userName;
    },
    isAdmin() {
      if (this.$store.state.perfiles.includes("Administrador")) {
        console.log(this.$store.state.perfiles.includes("Administrador"));
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("clearToken");
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
.font-header {
  color: black;
}
.font-header-white {
  color: white;
}
.bgc-header {
  background-color: #3c4b64 !important;
}
.bgc-header-white {
  background-color: #ffffff !important;
}
.no-padding {
  padding: 0 !important;
}
.custom-padding {
  padding: 8px 20px;
}
.router-width {
  width: 100%;
  text-decoration: none;
  color: #4f5d73;
}
.font-type {
  vertical-align: middle;
}
</style>
